import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static siteDeleteForce(postId) {
        return PostApiBase.siteDeleteForce({
            post_id: postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
